import {Action, createReducer, on} from '@ngrx/store';
import {
  DeliveryRestrictionsState,
  initialDeliveryRestrictionsState,
} from '@appModels/store/delivery-restrictions/delivery-restrictions.model';
import * as deliveryRestrictionsActions from '@appActions/delivery-restrictions/delivery-restrictions.actions';
import {RestriccionFechasPreviewExtended} from '@appModels/delivery-restrictions/delivery-restrictions.models';

const _deliveryRestrictionsReducer = createReducer<DeliveryRestrictionsState>(
  initialDeliveryRestrictionsState(),
  on(
    deliveryRestrictionsActions.SET_EDIT_MODE,
    (state: DeliveryRestrictionsState, {isEditMode}) => {
      if (isEditMode) {
        return {
          ...state,
          isEditMode,
          backUpDeliveryRestrictions: state.deliveryRestrictionSavedConfiguration,
        };
      }

      return {
        ...state,
        isEditMode,
        deliveryRestrictionSavedConfiguration: state.backUpDeliveryRestrictions,
        deliveryRestrictionConfiguration: [],
        deliveryRestrictionsToEdit: [],
        deliveryRestrictionsToDelete: [],
        backUpDeliveryRestrictions: [],
      };
    },
  ),
  on(
    deliveryRestrictionsActions.SET_TRANSLATION,
    (
      state: DeliveryRestrictionsState,
      {
        months,
        days,
        daysAbbreviated,
        labelsCards,
        labelsCalendar,
        labelsConfigModal,
        labelsModalDelete,
        labelsModalEdit,
      },
    ) => ({
      ...state,
      translate: {
        ...state.translate,
        months,
        days,
        daysAbbreviated,
        labelsCards,
        labelsCalendar,
        labelsConfigModal,
        labelsModalDelete,
        labelsModalEdit,
      },
    }),
  ),
  on(
    deliveryRestrictionsActions.SET_CONFIGURATION_PREVIEW_SUCCESS,
    (state: DeliveryRestrictionsState, {newConfigurationPreview}) => {
      const newRestriction: RestriccionFechasPreviewExtended = {
        NewConfiguration: newConfigurationPreview.NewConfiguration,
        IdConfigRestriction: newConfigurationPreview.IdConfigRestriction,
        Configuracion: newConfigurationPreview.Configuracion,
        Fechas: newConfigurationPreview.Fechas,
      };

      if (newConfigurationPreview.isEditMode) {
        return {
          ...state,
          deliveryRestrictionConfiguration: state.deliveryRestrictionConfiguration.map((item) =>
            item.IdConfigRestriction === newRestriction.IdConfigRestriction ? newRestriction : item,
          ),
        };
      }

      return {
        ...state,
        deliveryRestrictionConfiguration: [
          ...state.deliveryRestrictionConfiguration,
          newRestriction,
        ],
      };
    },
  ),
  on(
    deliveryRestrictionsActions.SET_CONFIGURATION_PREVIEW_EDIT,
    (state: DeliveryRestrictionsState, {configurationDR}) => {
      const exists = state.deliveryRestrictionsToEdit.some(
        (item) => item.IdConfigRestriction === configurationDR.IdConfigRestriction,
      );

      return {
        ...state,
        deliveryRestrictionsToEdit: exists
          ? state.deliveryRestrictionsToEdit.map((item) =>
              item.IdConfigRestriction === configurationDR.IdConfigRestriction
                ? configurationDR
                : item,
            )
          : [...state.deliveryRestrictionsToEdit, configurationDR],
        deliveryRestrictionSavedConfiguration: state.deliveryRestrictionSavedConfiguration.map(
          (item: RestriccionFechasPreviewExtended) =>
            item?.IdConfigRestriction === configurationDR.IdConfigRestriction
              ? configurationDR
              : item,
        ),
      };
    },
  ),
  on(
    deliveryRestrictionsActions.SET_CONFIGURATION_TO_DELETE,
    (state: DeliveryRestrictionsState, {IdConfiguration, isNewConfiguration}) => {
      const savedConfig = state.deliveryRestrictionSavedConfiguration.filter(
        (item) => item.IdConfigRestriction !== IdConfiguration,
      );
      const newConfig = state.deliveryRestrictionConfiguration.filter(
        (item) => item.IdConfigRestriction !== IdConfiguration,
      );
      return {
        ...state,
        deliveryRestrictionSavedConfiguration: savedConfig,
        deliveryRestrictionConfiguration: newConfig,
        deliveryRestrictionsToDelete: [
          ...state.deliveryRestrictionsToDelete,
          ...(!isNewConfiguration ? [IdConfiguration] : []),
        ],
      };
    },
  ),
  on(
    deliveryRestrictionsActions.GET_RESTRICTIONS_CONFIGURATION_SAVED_SUCCESS,
    (state: DeliveryRestrictionsState, {listConfiguration}) => ({
      ...state,
      deliveryRestrictionSavedConfiguration: listConfiguration,
      isEditMode: false,
    }),
  ),
  on(
    deliveryRestrictionsActions.SAVE_ALL_CONFIGURATION_SUCCESS,
    (state: DeliveryRestrictionsState) => ({
      ...state,
      deliveryRestrictionConfiguration: [],
      deliveryRestrictionsToEdit: [],
      deliveryRestrictionsToDelete: [],
    }),
  ),
  on(
    deliveryRestrictionsActions.CONFIGURATION_DELIVERY_RESTRICTIONS_EDIT_SUCCESS,
    (state: DeliveryRestrictionsState) => ({
      ...state,
      deliveryRestrictionsToEdit: [],
    }),
  ),
  on(
    deliveryRestrictionsActions.CONFIGURATION_DELIVERY_RESTRICTIONS_DELETED_SUCCESS,
    (state: DeliveryRestrictionsState) => ({
      ...state,
      deliveryRestrictionsToDelete: [],
    }),
  ),
  on(deliveryRestrictionsActions.CLEAR_DELIVERY_RESTRICTIONS, (state: DeliveryRestrictionsState) =>
    initialDeliveryRestrictionsState(),
  ),
);

export function deliveryRestrictionsReducer(
  state: DeliveryRestrictionsState | undefined,
  action: Action,
) {
  return _deliveryRestrictionsReducer(state, action);
}
